import Box from '@mui/material/Box'
import MenusFull from './MenusFull'
import MenusMinimized from './MenusMinimized'

const Menus = ({ minimizeMenu }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        '& > :first-child': { marginTop: '42px' },
        '& > :last-child': { marginBottom: '90px' }
      }}
    >
      {minimizeMenu ? <MenusMinimized /> : <MenusFull />}
    </Box>
  )
}

export default Menus
